<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />
    <div class="writeGridContainer">
      <div>
        <div>업체명</div>
        <div>
          <CompanySelector class="w-full flex-1" v-model="form.업체" :readonly="board.readonly" @select="selectCompany"></CompanySelector>
        </div>
      </div>
    </div>

    <!--  -->
    <div class="mt-8">
      <div class="mb-4">
        <h5><i class="dot"></i>산업안전보건관리비</h5>
      </div>

      <table class="w-full">
        <thead>
          <tr>
            <th>예산</th>
            <th>집행실적</th>
            <th>지출잔액</th>
            <th>집행률(%)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <number-input v-model="form.관리비.예산" />
            </td>
            <td>
              <number-input v-model="form.관리비.집행실적" />
            </td>
            <td>
              <div class="print-input text-right bg-transparent">
                {{ form.관리비.지출잔액 | comma }}
              </div>
            </td>
            <td>
              <div class="print-input text-right bg-transparent">
                {{ form.관리비.집행률 }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import NumberInput from "@/components/NumberInput.vue";
import CompanySelector from "@/components/selector/CompanySelector";

export default {
  components: {
    NumberInput,
    FileUploadModule,
    FieldSelectModule,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        관리비: {
          예산: 0,
          집행실적: 0,
          지출잔액: 0,
          집행률: 0.0,
        },
        fileList: [],

        업체명: "",
        업체: null,
      },
    };
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    "form.관리비": {
      deep: true,
      handler(관리비) {
        관리비.지출잔액 = 관리비.예산 - 관리비.집행실적;
        관리비.집행률 = (관리비.예산 > 0 ? (관리비.집행실적 / 관리비.예산) * 100 : 0).toFixed(2);
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    selectCompany(data) {
      this.form.업체명 = data.com_name;
    },
  },
};
</script>
<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  text-align: center;
  border-left: solid 1px #cdcdcd;

  thead {
    background: #f9f9f9;
    z-index: 0 !important;

    th {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: #3c3c3c;

      border-top: solid 1px #cdcdcd;
      border-right: solid 1px #cdcdcd;
      border-bottom: solid 1px #cdcdcd;
      padding: 16px 0;

      text-align: center;
    }
  }
  tbody {
    tr {
      background: #f9f9f9;
      border-bottom: solid 1px #cdcdcd;

      td {
        border-right: solid 1px #cdcdcd;
        padding: 6px;
      }
    }
  }
}
</style>
